import React from 'react';

// Brand colors for major Indian banks
const BANK_BRANDS = {
  'State Bank of India': { bg: '#22409A', text: 'SBI', subtitle: 'BANK', textColor: '#FFFFFF' },
  'HDFC Bank': { bg: '#004C8F', text: 'HDFC', subtitle: 'BANK', textColor: '#FFFFFF', accent: '#ED232A' },
  'ICICI Bank': { bg: '#F58220', text: 'ICICI', subtitle: 'Bank', textColor: '#FFFFFF', accent: '#AE1F23' },
  'Axis Bank': { bg: '#97144D', text: 'AXIS', subtitle: 'BANK', textColor: '#FFFFFF' },
  'Punjab National Bank': { bg: '#9C1B1F', text: 'PNB', subtitle: 'Bank', textColor: '#FFD200' },
  'Kotak Mahindra Bank': { bg: '#EF3E23', text: 'Kotak', subtitle: 'Mahindra', textColor: '#FFFFFF' }
};

const BANK_SHORT = {
  'State Bank of India': 'SBI',
  'HDFC Bank': 'HDFC',
  'ICICI Bank': 'ICICI',
  'Axis Bank': 'AXIS',
  'Punjab National Bank': 'PNB',
  'Kotak Mahindra Bank': 'Kotak'
};

const BankLogo = ({ bankName, size = 80, variant = 'card' }) => {
  const brand = BANK_BRANDS[bankName] || { bg: '#FF6B35', text: bankName?.split(' ')[0] || 'Bank', subtitle: '', textColor: '#FFFFFF' };
  
  if (variant === 'compact') {
    // Compact circular badge style
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: brand.bg,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: brand.textColor,
          fontFamily: 'Outfit, sans-serif',
          fontWeight: 800,
          fontSize: `${size * 0.22}px`,
          letterSpacing: '0.02em',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        {brand.text}
      </div>
    );
  }
  
  // Card style logo
  return (
    <div
      style={{
        width: '100%',
        height: size,
        borderRadius: '0.5rem',
        background: brand.bg,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: brand.textColor,
        fontFamily: 'Outfit, sans-serif',
        position: 'relative',
        overflow: 'hidden',
        padding: '0.5rem'
      }}
    >
      <div style={{ 
        fontWeight: 900, 
        fontSize: `${Math.min(size * 0.32, 28)}px`, 
        letterSpacing: '0.05em',
        lineHeight: 1,
        textAlign: 'center'
      }}>
        {brand.text}
      </div>
      {brand.subtitle && (
        <div style={{ 
          fontWeight: 600, 
          fontSize: `${Math.min(size * 0.16, 13)}px`, 
          marginTop: '4px',
          opacity: 0.85,
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }}>
          {brand.subtitle}
        </div>
      )}
      {brand.accent && (
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '20%',
          height: '100%',
          background: brand.accent,
          opacity: 0.4
        }} />
      )}
    </div>
  );
};

export { BANK_SHORT };
export default BankLogo;
